import { Grid, GridItem } from '@chakra-ui/react'
import InternalAppShell from '../../InternalAppShell'

export default function MainContainer({ children }: any) {
  return (
    <InternalAppShell contentMode="full">
      <Grid
        templateColumns={{
          base: 'minmax(0, 1fr)',
          lg: 'minmax(0, 1fr) 280px',
          xl: 'minmax(0, 1fr) 320px'
        }}
        minH="calc(100vh - 48px)"
        alignItems="stretch"
        columnGap={{ base: 0, lg: 2 }}
        bg="gray.50"
      >
        <GridItem minW={0}>{children[0]}</GridItem>
        <GridItem minW={0}>{children[1]}</GridItem>
      </Grid>
    </InternalAppShell>
  )
}
